export default __webpack_public_path__ + "images/S3.857c492.png";